exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hotspot-form-container .label[data-v-da524714]{font-weight:bold;font-size:16px;line-height:1.5}.hotspot-form-container .upload-img[data-v-da524714]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;cursor:pointer}.hotspot-form-container .upload-img span[data-v-da524714]{white-space:nowrap}.hotspot-form-container .upload-img .img[data-v-da524714]{-webkit-box-flex:1;-ms-flex:1;flex:1;max-height:300px}.hotspot-form-container .upload-img .img img[data-v-da524714]{width:100%}", ""]);

// exports
